import React from 'react';
import PropTypes from 'prop-types';
import {createStore} from 'redux';
import {Provider} from 'react-redux';

import reducers from '../redux/reducers';
import {eventTypes} from './events';

class WithContext extends React.Component {
    static propTypes = {
        children: PropTypes.node.isRequired,
    };

    static childContextTypes = {
        i18n: PropTypes.func,
    };

    getChildContext() {
        return {
            i18n: x => x,
        };
    }

    render() {
        return (
            <div>
                {this.props.children}
            </div>
        );
    }
}

export const testingMockData = {
    args: {
        context: {
            i18n: x => x,
        },
        childContextTypes: {
            i18n: x => x,
        }
    },
    argsContextOnly: {
        context: {
            i18n: x => x,
        },
    },
    someEvent: {
        description: 'desc',
        eventId: 'someId',
        helpLink: 'help link',
        type: 'error',
        title: 'foo',
    },
    getEventByType: (type = eventTypes.error) => ({
        ...testingMockData.someEvent,
        type,
    }),
    connect: (component, defaultState = {}) => {
        const store = createStore(reducers, defaultState);
        return {
            store,
            component: <WithContext><Provider store={store}>{component}</Provider></WithContext>,
        };
    }
};



// WEBPACK FOOTER //
// ./src/constants/testing.js